import $ from 'jquery';

import { CreateNewLeadPopupCtrl } from '../create.new.lead.popup/create.new.lead.popup.controller';
import newLeadPopupTemplate from '../create.new.lead.popup/create.new.lead.popup.html';
import { LeadPopupCtrl } from '../lead.popup/lead.popup.controller';
import leadPopupTemplate from '../lead.popup/lead.popup.html';
import template from '../leads/leads.html';
import sidebarTemplate from '../leads/leads.sidebar.html';
import unitPopupTemplate from '../unit.popup/unit.popup.html';
import { UnitPopupCtrl } from '../unit.popup/UnitPopupCtrl';
import { LeadsCtrl } from './leads.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('leads', {
      url: '/leads',
      controller: LeadsCtrl,
      controllerAs: 'vm',
      template,
      redirectTo: 'leads.search',
    })
    .state('leads.search', {
      url: '/search',
      views: {
        sidebar: {
          template: sidebarTemplate,
        },
      },
    })
    .state('leads.unitpopup', {
      url: '/unit/:id',
      views: {
        sidebar: {
          controller: UnitPopupCtrl,
          controllerAs: 'vm',
          template: unitPopupTemplate,
        },
      },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('leads.leadpopup', {
      url: '/lead/:id',
      views: {
        sidebar: {
          controller: LeadPopupCtrl,
          controllerAs: 'vm',
          template: leadPopupTemplate,
        },
      },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('leads.new', {
      url: '/new?phone',
      views: {
        sidebar: {
          controller: CreateNewLeadPopupCtrl,
          controllerAs: 'vm',
          template: newLeadPopupTemplate,
        },
      },
      params: { phoneOrEmail: null },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    });
}
